import mod from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./live-loading.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./live-loading.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/components/live-loading.vue?vue&type=script&lang=js&
// module id = 8Uj8
// module chunks = 0